import React from "react";
import ReactGA from "react-ga";
import { useStaticQuery, graphql } from "gatsby";

import ButtonLink from "components/ButtonLink";
import Layout from "components/Layout";
import SEO from "components/Seo";
import GridTemplate from "components/GridTemplate";
import Verify from "components/Verify";

const IndexPage = () => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            descriptionEn
          }
        }
      }
    `
  );

  return (
    <Layout>
      <SEO
        lang="en"
        title="Verify Bitcoin Signature"
        description={site.siteMetadata.descriptionEn}
      />
      <GridTemplate>
        <Verify language="en" fullText={true} />
      </GridTemplate>
    </Layout>
  );
};

export default IndexPage;
